module Meevo.Plugins.Client {

    import IClientForm = Meevo.Plugins.DocsAndForms.IClientForm;
    import IClientFormService = Meevo.Plugins.DocsAndForms.IClientFormService;
    import AppointFinalStateEnum = Meevo.Model.AppointFinalStateEnum;
    import AppointStateEnum = Meevo.Model.AppointStateEnum;
    import DocsAndFormsApiService = Meevo.Plugins.DocsAndForms.DocsAndFormsApiService;
    import IShowFormOptionRow = Meevo.Plugins.DocsAndForms.IShowFormOptionRow;
    import DocsAndFormsService = Meevo.Plugins.DocsAndForms.DocsAndFormsService;
    import LocationListItem = Meevo.Model.LocationListItem;

    interface IAccordionData {
        entity: any;
        multiple: boolean;
        level: number;
        expanded: boolean;
        data: IAccordionData[];
        childData: IAccordionData[];
    }

    class FormsAccordionComponent implements ng.IComponentController {

        static $inject = [
            'meevo.components.busy.BusyService',
            'meevo.plugins.docsAndForms.DocsAndFormsApiService',
            'meevo.components.modal.ModalService',
            '$translate',
            'meevo.plugins.docsAndForms.DocsAndFormsService',
        ];


        //#region Bindings
        set forms(forms: IClientForm[]) {
            if (!this.accordionLevels) this.accordionLevels = [];

            this.accordionData = this.accordionLevels[0] = (forms || []).map(form => {
                return {
                    level: 0,
                    multiple: false,
                    childData: [],
                    entity: form,
                    expanded: false,
                    data: (() => {
                        const data = form.services.map(service => {
                            const isAppointmentServiceCancelled = service.appointmentServiceFinalState === AppointFinalStateEnum.Cancelled && !service.appointmentIsActive;
                            const isAppointmentServiceRemoved = service.appointmentServiceFinalState === AppointFinalStateEnum.Removed
                                                                || service.appointmentServiceFinalState === AppointFinalStateEnum.Replaced
                                                                || (service.appointmentServiceFinalState === AppointFinalStateEnum.Cancelled && service.appointmentIsActive);
                            const isAppointmentServiceNoShow = service.appointmentServiceTransitionState === AppointStateEnum.NoShow;

                            return {
                                level: 1,
                                multiple: false,
                                childData: [],
                                entity: {
                                    ...service,
                                    isAppointmentServiceCancelled,
                                    isAppointmentServiceRemoved,
                                    isAppointmentServiceNoShow,
                                    isAppointmentStatus: isAppointmentServiceCancelled || isAppointmentServiceRemoved || isAppointmentServiceNoShow,
                                },
                                expanded: false,
                                data: service.pdfUrlHistoryList.map(pdf => {
                                    return {
                                        level: 2,
                                        multiple: false,
                                        childData: [],
                                        data: [],
                                        entity: pdf,
                                        expanded: false
                                    }
                                })
                            }
                        });

                        if (!this.accordionLevels[1]) this.accordionLevels[1] = [];

                        this.accordionLevels[1].push(...data);

                        return data;
                    })()
                }
            });
        };

        locations: LocationListItem[] = [];
        locationId: string;
        client: Meevo.Model.Client;
        moduleActive: boolean;
        loadForms: () => void;
        //#endregion

        accordionData: IAccordionData[] = [];
        accordionLevels: IAccordionData[][] = [];
        locationCache: Record<string, LocationListItem> = {};

        constructor(private _busyService: Meevo.Components.Busy.IBusyService,
                    private _docsAndFormsApi: DocsAndFormsApiService,
                    private _modalService: Meevo.Components.Modal.IModalService,
                    private _translateService: angular.translate.ITranslateService,
                    private _docsAndFormsService: DocsAndFormsService) {
        }

        expandToggle(row: IAccordionData, expanded = !row.expanded) {
            // if row does not support multiple blocks opened, close all block first
            if (!row.multiple && this.accordionLevels[row.level] instanceof Array) {
                for (const level of this.accordionLevels[row.level]) {
                    level.expanded = false;
                }
            }

            row.expanded = expanded;

            // set childData property to render it on the view
            if (row.expanded && row.childData.length == 0) {
                row.childData = row.data;
            }
            // open child block if it is the single block
            if (row.expanded && row.childData.length === 1) {
                this.expandToggle(row.childData[0], true);
            }
        }

        openForm(form: IClientForm, service: IClientFormService) {
            const showFormRow: IShowFormOptionRow = {
                formDisplayName: service.displayName,
                formId: service.id,
                formUrl: service.formUrl,
                serviceId: service.appointmentServiceId
            };

            this._docsAndFormsService.showForm(showFormRow, this.client.id).then(() => {
                this.loadForms();
            });
        }

        resendForm(service: IClientFormService) {
            this._busyService.start();

            this._docsAndFormsApi.resendForm({
                clientId: service.clientId,
                formId: service.id,
                appointmentId: service.appointmentId,
                appointmentServiceId: service.appointmentServiceId
            })
                .then(() => {
                    this._modalService.message(
                        this._translateService.instant('MESSAGE_FORM_SENT', {
                            formDisplayName: service.displayName
                        })
                    );
                })
                .finally(() => {
                this._busyService.stop();
            });
        }

        locationNameById(locationId: number): string {
            const cachedLocation = this.locationCache[locationId.toString()];
            if (cachedLocation) return cachedLocation.storeName;

            const location = this.locationCache[locationId.toString()] = this.locations.find((location) => location.id === locationId);

            return location ? location.storeName : '';
        }

        email(item: IGroupedClientForm, selectedPDF?: string) {
            if (!selectedPDF) {
                return;
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/client/sectionViews/selectEmail.modal.html',
                controller: 'meevo.plugins.client.SelectEmailController',
                controllerAs: 'vm',
                bindToController: true,
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: {
                    email: this.client.emailAddress
                }
            };

            this._modalService.showCustom(options, 0, true).then(email => {
                this._docsAndFormsApi.sendWithEmail({
                    email,
                    clientId: item.clientId,
                    displayName: item.displayName,
                    selectedPDF: selectedPDF,
                });
            });
        }
    }

    angular.module('meevo.plugins.client')
        .component('meevoClientFormsAccordion', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/client/components/forms-accordion/forms-accordion.component.html',
            controller: FormsAccordionComponent,
            controllerAs: '$ctrl',
            bindings: {
                forms: '<',
                locationId: '@',
                moduleActive: '<',
                client: '<',
                locations: '<',
                loadForms: '&',
            }
        });
}
